import { createAction } from 'signin-app/redux/helpers';
const domain = 'PIN';
export const { action: setPinValue } = createAction(`${domain}/SET_PIN_VALUE`, (newValue) => ({ newValue }));
export const { action: pinLogout } = createAction(`${domain}/PIN_LOGOUT`, () => ({}));
export const { action: updateChild } = createAction(`${domain}/UPDATE_CHILD`, (updatedChildProps) => ({
    updatedChildProps,
}));
export const { action: updateEmployee } = createAction(`${domain}/UPDATE_EMPLOYEE`, (updatedEmployeeProps) => ({
    updatedEmployeeProps,
}));
export const { action: pinLogin, success: pinLoginSuccess, failed: pinLoginFailed, } = createAction(`${domain}/PIN_LOGIN`, (pin) => ({ pin }), (response) => ({ response }));
